module.exports = __webpack_public_path__ + "img/heading_no.b07fcf6a.svg";